export const MANAGEMENT_TABS = {
  WORKSPACES: 0,
  ACCOUNTANTS: 1,
} as const
